export default "__VITE_ASSET__1afbeb93__"